import React from "react";
import { SEO } from "../components/SEO";
import { Hero } from "../components/home/Hero";
import { Credibility } from "../components/home/Credibility";
import { WhatIsODF } from "../components/home/WhatIsODF";
import { WhyNortis } from "../components/home/WhyNortis";
import { SolutionsPortfolio } from "../components/home/SolutionsPortfolio";
import { Comparison } from "../components/home/Comparison";
import { PartnershipModels } from "../components/home/PartnershipModels";
import { Timeline } from "../components/home/Timeline";
import { Quality } from "../components/home/Quality";
import { GlobalOutlook } from "../components/home/GlobalOutlook";
import { FinalCTA } from "../components/home/FinalCTA";

export default function HomePage() {
  return (
    <>
      <SEO page="home" />
      <Hero />
      <Credibility />
      <WhatIsODF />
      <WhyNortis />
      <SolutionsPortfolio />
      <Comparison />
      <PartnershipModels />
      <Timeline />
      <Quality />
      <GlobalOutlook />
      <FinalCTA />
    </>
  );
}
